import EllipsisPopupButton from "../../../../components/buttons/ellipsisPopupButton/EllipsisPopupButton";
import { BasicLinkButton, DeleteLinkButton } from "../../../../components/buttons/linkButtons";

export interface AccountEllipsisPopupButtonProps {
  circle?: boolean;
  position?: string;
  outlinedEllipsis?: boolean;
  disabled?: boolean;
  accountId: number;
  accountName: string;
  canView?: boolean;
  canDelete?: boolean;
  onOpenMobo?: (id: number) => void;
  onDelete?: (id: number, name: string) => void;
}

function AccountEllipsisPopupButton(props: AccountEllipsisPopupButtonProps) {
  const { accountId, accountName, onOpenMobo, onDelete, canView, canDelete, ...ellipsisProps } = props;

  return (
    <EllipsisPopupButton circle outlinedEllipsis {...ellipsisProps}>
      <BasicLinkButton
        onClick={() => onOpenMobo?.(accountId)}
        isDisabled={!canView}
        text="Manage"
        iconClassName="fa-solid fa-key"
      />
      <DeleteLinkButton onClick={() => onDelete?.(accountId, accountName)} isDisabled={!canDelete} />
    </EllipsisPopupButton>
  );
}

AccountEllipsisPopupButton.defaultProps = {
  position: "bottom right",
  disabled: false,
};

export default AccountEllipsisPopupButton;
